<template lang="">
<div class="modal width2">
        <a  class="modal_close" @click="$emit('close')"></a>
        <div class="modal_header">
            <div class="title">현금영수증 발행 정보 수정</div>
        </div>
        <div class="modal_body">
            <ul class="modal_list">
                <li>정보를 기입하신 후 발행하기 버튼을 클릭해 주세요.</li>
            </ul>
            <div class="modal_tbl">
                <table>
                    <tbody>
                        <tr>
                            <th>상품명</th>
                            <td class="product_name">[결식아동] 디지털화환 특가</td>
                        </tr>
                        <tr>
                            <th>결제금액</th>
                            <td>53,800원</td>
                        </tr>
                        <tr>
                            <th>공급가액</th>
                            <td>48,900원</td>
                        </tr>
                        <tr>
                            <th>부가세</th>
                            <td>4,891원</td>
                        </tr>
                        <tr>
                            <th>봉사료</th>
                            <td>0원</td>
                        </tr>
                        <tr>
                            <th>구매자명</th>
                            <td>
                                <div class="wrapper">
                                    <input type="text">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>이메일</th>
                            <td>
                                <div class="wrapper">
                                    <input type="text">
                                    <span class="at">@</span>
                                    <input type="text">
                                    <div class="select_box email">
                                        <button type="button" class="btn_select">직접입력</button>
                                        <ul class="select_list">
                                            <li><button>naver.com</button></li>
                                            <li><button>gmail.com</button></li>
                                        </ul>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                현금영수증구분/ <br>증빙서류
                            </th>
                            <td>
                                <div class="wrapper">
                                    <label for="deduction" class="radio_wrap">
                                        <input type="radio" id="deduction" name="receipt">
                                        <span>소득공제용</span>
                                    </label>
                                    <label for="proof" class="radio_wrap">
                                        <input type="radio" id="proof" name="receipt">
                                        <span>지출증빙용</span>
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                현금영수증 발행
                            </th>
                            <td>
                                <div class="wrapper">
                                    <label for="phone" class="radio_wrap">
                                        <input type="radio" id="phone" name="type">
                                        <span>휴대폰</span>
                                    </label>
                                    <label for="card" class="radio_wrap">
                                        <input type="radio" id="card" name="type">
                                        <span>카드번호</span>
                                    </label>
                                </div>
                                <div class="wrapper">
                                    <div class="select_box num">
                                        <button type="button" class="btn_select">010</button>
                                        <ul class="select_list">
                                            <li><button>02</button></li>
                                            <li><button>010</button></li>
                                            <li><button>032</button></li>
                                        </ul>
                                    </div>
                                    <span class="hyphen">-</span>
                                    <input type="text" class="num">
                                    <span class="hyphen">-</span>
                                    <input type="text" class="num">
                                </div>
                                <p class="alarm">국세청에 현금영수증 발행용 휴대폰번호 및 카드번호를 사전 등록하시고 이용바랍니다.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="common_btn type2">
                <button type="button" class="btn_close">닫기</button>
                <button type="button" class="btn_print">인쇄하기</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>